type LogoMarkTrayProps = Omit<React.SVGProps<SVGSVGElement>, 'width' | 'height'> & {
  size: number;
};

export const LogoMarkTray = ({ size, ...props }: LogoMarkTrayProps) => {
  return (
    <svg
      {...props}
      width={size}
      height={size}
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_tray)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 0V5H0V0H16ZM10.72 8L16 20H10.665L8 13L5.335 20H0L5.28 8H10.72Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_tray">
          <rect width="16" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
